 async function renderCoverageWidget(productSKU, container, market) {  
  var myHeaders = new Headers();
  myHeaders.append('pragma', 'no-cache');
  myHeaders.append('cache-control', 'no-cache');
  
  var myInit = {
    method: 'GET',
    headers: myHeaders,
  };
  var ms = Date.now();
  var currUrl = "/?sections=coverage-checker-simple-inn&tool=" + productSKU +"&dummy="+ms;

  var myRequest = new Request(currUrl);
  var appendToBody = await fetch(currUrl, myInit)
  .then(response => response.json()) 
  .then(data => { 
    var text = data["coverage-checker-simple-inn"];    
    //replace market
    var findText = '<input id="Market" name="Market" type="hidden" value="';
    text = replaceNewParams(text, findText, market, '">');
    //replace tool
    findText = '<input id="sku" name="sku" type="hidden" value="';
    text = replaceNewParams(text, findText, productSKU, '">');
    //append new section
    $(container).append(text); 
  });
}

  async function renderCoverageSubsetWidget(productSKU, displayedSections, container, market, title, subtitle) {  
   var myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
   var ms = Date.now();

   if(title == null || title == undefined){
     title = "";
   }
   if(subtitle == null || subtitle == undefined){
     subtitle = "";
   }
   var currUrl = "/?sections=coverage-subset-template-inn&tool=" + productSKU +"&displayedsections="+ displayedSections + "&market="+ market + "&title="+ title + "&subtitle="+ subtitle +"&dummy="+ms;  
   var myRequest = new Request(currUrl);
    var appendToBody = await fetch(currUrl, myInit)
    .then(response => response.json()) 
    .then(data => { 
      var text = data["coverage-subset-template-inn"];      
      //replace market
      var findText = '<input id="Market" name="Market" type="hidden" value="';      
      text = replaceNewParams(text, findText, market, '">');
      //replace tool
      findText = '<input id="sku" name="sku" type="hidden" value="';
      text = replaceNewParams(text, findText, productSKU, '">');
      //replace display sections
      findText = '<input id="CoverageSections" name="CoverageSections" type="hidden" value="';
      text = replaceNewParams(text, findText, displayedSections, '">');
      //replace title
      findText = '<p id="inn-header-title" class="text-center fs-32-48 semibold">';
      text = replaceNewParams(text, findText, title, '</');
      //replace subtitle
      findText = '<p id="inn-header-subtitle" class="text-center mb-4 hide-br-mobile">';
      text = replaceNewParams(text, findText, subtitle, '</');
      
      // //append new section
      $(container).append(text); 
      // if(title != "" || subtitle != ""){
      //   $(".container").addClass("mt-5");
      // }else{
      //   $(".container").removeClass("mt-5");
      // }
      
    });
  }

  async function renderCoverageCheckerPageWidget(container, hideHeader) {  
   var isHideHeader = true;
   if(hideHeader != null && hideHeader != undefined){
     isHideHeader = hideHeader.toString().toLowerCase() == "true";
   }
   var myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
   var ms = Date.now();
   var currUrl = "/?sections=coverage-page-template-inn&dummy="+ms;    
   var myRequest = new Request(currUrl);
    var appendToBody = await fetch(currUrl, myInit)
    .then(response => response.json()) 
    .then(data => { 
      //IsHiddenHeader
      var text = data["coverage-page-template-inn"];      
      $(container).html(text);      
      if(isHideHeader == true){
        $("#coverage-header").hide();
      }
    });
  }

  async function renderCoverageAutozoneWidget(container, hideHeader) {  
   var isHideHeader = true;
   if(hideHeader != null && hideHeader != undefined){
     isHideHeader = hideHeader.toString().toLowerCase() == "true";
   }
   var myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
   var ms = Date.now();
   var currUrl = "/?sections=coverage-page-autozone-inn&dummy="+ms;    
   var myRequest = new Request(currUrl);
    var appendToBody = await fetch(currUrl, myInit)
    .then(response => response.json()) 
    .then(data => { 
      //IsHiddenHeader
      var text = data["coverage-page-autozone-inn"];      
      $(container).html(text);      
      if(isHideHeader == true){
        $("#coverage-header").hide();
      }
    });
  }

  async function renderCoverageAdvanceWidget(container, hideHeader) {  
   var isHideHeader = true;
   if(hideHeader != null && hideHeader != undefined){
     isHideHeader = hideHeader.toString().toLowerCase() == "true";
   }
   var myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
   var ms = Date.now();
   var currUrl = "/?sections=coverage-page-advance-inn&dummy="+ms;    
   var myRequest = new Request(currUrl);
    var appendToBody = await fetch(currUrl, myInit)
    .then(response => response.json()) 
    .then(data => { 
      //IsHiddenHeader
      var text = data["coverage-page-advance-inn"];      
      $(container).html(text);      
      if(isHideHeader == true){
        $("#coverage-header").hide();
      }
    });
  }

  async function renderCoverageOreillyWidget(container, hideHeader) {  
   var isHideHeader = true;
   if(hideHeader != null && hideHeader != undefined){
     isHideHeader = hideHeader.toString().toLowerCase() == "true";
   }
   var myHeaders = new Headers();
    myHeaders.append('pragma', 'no-cache');
    myHeaders.append('cache-control', 'no-cache');
    
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
   var ms = Date.now();
   var currUrl = "/?sections=coverage-page-oreilly-inn&dummy="+ms;    
   var myRequest = new Request(currUrl);
    var appendToBody = await fetch(currUrl, myInit)
    .then(response => response.json()) 
    .then(data => { 
      //IsHiddenHeader
      var text = data["coverage-page-oreilly-inn"];      
      $(container).html(text);      
      if(isHideHeader == true){
        $("#coverage-header").hide();
      }
    });
  }

function replaceNewParams(text, findText, replaceText, endText) {
  var startIdx = text.indexOf(findText)
  if(startIdx > 0){
    var resultSub = text.substring(startIdx + findText.length, text.length);
    var endIdx = resultSub.indexOf(endText) 
    if(endIdx > 0){
        var result = resultSub.substring(0, endIdx);
        var retText = text.replace(result, replaceText); 
       return retText;
    }else if(endIdx == 0){
       var retText = text.substring(0, startIdx  + findText.length) + replaceText + resultSub;
       return retText;
    }
  }
  return text;  
}        
